import React from "react";
import store from "../../store";
import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Table,
  Icon
} from "semantic-ui-react";
import { connect } from "react-redux";
import { CSVDownload, CSVLink } from "react-csv";

// let { topItemLoader, lowItemLoader } = store.getState();

class TableData extends React.PureComponent {
  render() {
    let { componentData,currency,usePropsHeader } = this.props;
    const { header, data,keys } = componentData;
    var headers = ["PRODUCTS", "QUANTITY", "AMOUNT", "Margin", "BARCODE"];
    let csvObj = data.values || [];
    if (csvObj[0]) {
      if (csvObj[0].category)
        if (csvObj[0].category.category) {
          headers = [
            "PRODUCTS",
            "CATEGORY",
            "SUB-CATEGORY",
            "QUANTITY",
            "AMOUNT",
            "Margin",
            "BARCODE"
          ];
        }
    }

    const csvData = () => {
      let temp = [];
      let csvObj = data.values || [];
      if (usePropsHeader){
        for(let i =0;i<csvObj.length;i++){
          let tempArr = []
          for(let j=0;j<keys.length;j++){
            tempArr.push(csvObj[i][keys[j]])
          }
          temp.push(tempArr);
        }
        return temp;
      }
      
      if (csvObj[0]) {
      }
      for (var i = 0; i < csvObj.length; i++) {
        if (csvObj[i].barcode) {
          let barcode = `=""${csvObj[i].barcode.value}""`;
          let tempArray = [
            csvObj[i].category.value,
            csvObj[i].qty_cur.value,
            csvObj[i].amt_cur.value,
            csvObj[i].mar_cur.percent + "%",
            barcode
          ];
          if (csvObj[i].category.category) {
            tempArray.splice(
              1,
              -1,
              csvObj[i].category.category,
              csvObj[i].category.subcategory
            );
          }
          temp.push(tempArray);
        } else {
          temp.push([
            csvObj[i].category.value,
            csvObj[i].qty_cur.value,
            "Rs. " + csvObj[i].amt_cur.value,
            csvObj[i].mar_cur.percent + "%"
          ]);
        }
      }
      return temp;
    };
    const displayValue = (value, displayCurrency = "") => {
      if (value == undefined || value <= 0 || value == "No Sales") {
        return "-";
      }

      return displayCurrency + " " + value;
    };

    const formatNum = num => {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    let {topItemLoader,lowItemLoader}=this.props;
    // console.log
    return (
      <Grid.Column>
        <Grid.Row style={styles.heading}>
          <Header as="h5" style={styles.heading}>
            {header}
          </Header>

          <Icon name="loading" />
          {header ? (
            header.toLowerCase() === "top items by sales" ? (
              !topItemLoader ? (
                // null
                <CSVLink
                  filename={`${header}.csv`}
                  headers={headers}
                  // target="_blank"
                  data={csvData()}
                >
                  <Icon name="download" color="black" type="font-awesome" />
                </CSVLink>
              ) : null
            ) : header.toLowerCase() === "low items by sales" ? (
              !lowItemLoader ? (
                <CSVLink
                  filename={`${header}.csv`}
                  headers={headers}
                  // target="_blank"
                  data={csvData()}
                >
                  <Icon name="download" color="black" type="font-awesome" />
                </CSVLink>
              ) : null
            ) :
            // null 
            (
              <CSVLink
                filename={`${header}.csv`}
                headers={usePropsHeader? data.topHeaders:headers}
                // target="_blank"
                data={csvData()}
              >
                <Icon name="download" color="black" type="font-awesome" />
              </CSVLink>
            )
          ) : null}
        </Grid.Row>
        <Grid.Row>
          {data.values.length ? (
            <div className="scrollable-div_container">
              <Table fixed style={styles.mainTable}>
                <Table.Header>
                  {
                    usePropsHeader? 
                    <Table.Row style={styles.headerRow}>
                      {data.topHeaders.map((item,index)=>{
                      return (
                        <Table.HeaderCell key={index} textAlign={index===0?"left":'center'} style={styles.hederCell}>
                          {item}
                        </Table.HeaderCell>
                      )
                      })}
                    
                    </Table.Row>:
                    <Table.Row style={styles.headerRow}>
                  
                    <Table.HeaderCell textAlign="left" style={styles.hederCell}>
                      PRODUCTS
                    </Table.HeaderCell>
                    <Table.HeaderCell style={styles.hederCell}>
                      QTY
                    </Table.HeaderCell>
                    <Table.HeaderCell style={styles.hederCell}>
                      AMOUNT
                    </Table.HeaderCell>
                    <Table.HeaderCell style={styles.hederCell}>
                      MARGIN
                    </Table.HeaderCell>
                  </Table.Row>
                  }
                  
                </Table.Header>

                <Table.Body>
                  {usePropsHeader ? 
                  data.values.slice(0,10).map((item,index)=>{
                    return (
                      <Table.Row style={styles.tablerow} key={index}>
                      {keys.map((key,index2)=>{
                        return (
                        <Table.Cell
                          key={key}
                          verticalAlign="middle"
                          textAlign={index2===0?"left":"center"}
                          style={styles.tableCellfirst}
                        >
                          {isNaN(item[key])? item[key] :formatNum(item[key])}
                        </Table.Cell>)
                      })}
                    </Table.Row>
                    )
                  })
                  :
                  data.values.slice(0, 10).map((item, index) => {
                    return (
                      <Table.Row style={styles.tablerow} key={index}>
                        <Table.Cell
                          verticalAlign="middle"
                          textAlign="left"
                          style={styles.tableCellfirst}
                        >
                          {item.category.value}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {formatNum(item.qty_cur.value)}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {currency} {formatNum(item.amt_cur.value)}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="middle"
                          style={styles.tableCell}
                        >
                          {item.mar_cur.percent} {"%"}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })
                }


                </Table.Body>
              </Table>
            </div>
          ) : null}
        </Grid.Row>
      </Grid.Column>
    );
  }
}

const styles = {
  mainTable: {
    borderWidth: 0,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: "transparent"
  },
  tablerow: {
    textAlign: "center",
    fontFamily: "Roboto",
    backgroundColor: "none"
  },
  hederCell: {
    backgroundColor: "#ECF3FA",
    color: "#999",
    fontSize: 14,
    fontWeight: 300,
    paddingTop: 15,
    paddingBottom: 15,
    borderColor: "#c1c1c5",
    borderWidth: 0.7,
    borderRadius: 0
  },
  tableCellfirst: {
    backgroundColor: "#F9F9FE",
    color: "#999",
    fontSize: 14,
    paddingTop: 15,
    paddingBottom: 15,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  tableCell: {
    backgroundColor: "#F9F9FE",
    color: "#313131",
    fontSize: 14,
    paddingTop: 25,
    paddingBottom: 25,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  headerRow: {
    textAlign: "center",
    fontFamily: "Roboto"
  },
  heading: {
    fontSize: 16,
    color: "rgb(102, 104, 116)",
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 20,
    display: "flex",
    justifyContent: "space-between",
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto"
  }
};

export default connect(state => {
  return {
    topItemLoader: state.topItemLoader,
    lowItemLoader: state.lowItemLoader
  };
})(TableData);



// WEBPACK FOOTER //
// ./src/components/TableData/index.js